import React from "react";
import { useTranslation } from "react-i18next";

const WhatsCovered = () => {
  const { t } = useTranslation();

  return (
    <section>
      <h2>{t("whatsCovered.title")}</h2>
      <p dangerouslySetInnerHTML={{ __html: t("whatsCovered.paragraph") }} />
    </section>
  );
};

export default WhatsCovered;
